<template>
	<div :class="'input-item ' + classList + ' ' + containerClasses" :style="styles">
		<label class="input-label" :for="id" v-if="label !== ''"
			>{{ label }} <span class="asterisk" v-if="asterisk">*</span></label
		>
		<div class="input-field-block">
			<span class="input-append input-prefix" v-if="has_prefix">{{ prefix }}</span>
			<textarea
				style="min-height: 33px"
				:tabindex="tabindex"
				@focus="focus"
				@blur="blur"
				@input="update($event)"
				@change="change($event)"
				:id="id"
				:name="name"
				:value="value"
				@keydown="keydown($event)"
				:placeholder="placeholder"
				:style="inputStyles"
				:class="'textarea ' + classList + ' ' + extraClasses"
				:autofocus="autofocus"
				:spellcheck="spellcheck"
				:autocomplete="autocomplete"
				:readonly="readonly"
				:disabled="disabled"
				:required="required"
				:cols="cols"
				:rows="rows"
				:maxlength="maxlength"
			></textarea>
			<span class="input-append input-suffix" v-if="has_suffix">{{ suffix }}</span>
		</div>
		<p class="input-help error" v-if="error" v-html="error"></p>
		<p class="input-help" v-if="help !== ''" v-html="help"></p>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		id: { default: "" },
		name: { default: "" },
		value: {},
		placeholder: { default: "" },

		label: { default: "" },
		prefix: { default: "" },
		suffix: { default: "" },
		help: { default: "" },
		tabindex: { default: null },
		step: { default: null },
		maxlength: { default: false },

		error: { default: false },
		asterisk: { default: false },
		required: { default: false },
		disabled: { default: false },
		readonly: { default: false },
		autofocus: { default: false },
		spellcheck: { default: false },
		autocomplete: { default: "on" }, // on/off

		hasError: { default: false },
		hasSuccess: { default: false },
		isLoading: { default: false },
		isFull: { default: false },
		isModel: { default: true },

		rows: { default: "" },
		cols: { default: "" },
		extraClasses: { default: "" },
		containerClasses: { default: "" },
		width: { default: null },
		resizeType: { default: "none" },
		size: { default: "regular" }, // regular, large
    customStyle: { default: null },
	},

	data: function () {
		return {
			generatedInputStyles: [],
			hasFocus: false,
		};
	},

	methods: {
		update(e) {
			this.$emit("input", e.target.value);
		},

		focus() {
			this.hasFocus = true;
			this.$emit("focus");
		},

		change(e) {
			this.$emit("change", e);
		},

		keydown(e) {
			this.$emit("keydown", e);
		},

		blur() {
			this.hasFocus = false;
			this.$emit("blur");
		},
	},

	computed: {
		styles() {
			let style = {};

			if (this.width !== null) {
				style["width"] = this.width;
			}

			return style;
		},

		inputStyles() {
			let style = this.customStyle || {};

			this.generatedInputStyles.forEach(function (item) {
				style[item.type] = item.value;
			});

			return style;
		},

		has_suffix() {
			return this.suffix && this.suffix !== "";
		},

		has_prefix() {
			return this.prefix && this.prefix !== "";
		},

		classList() {
			let classList = "";

			classList += " size-" + this.size;
			classList += " type-" + this.type;

			if (this.has_suffix) {
				classList += " has-suffix";
			}

			if (this.has_prefix) {
				classList += " has-prefix";
			}

			if (this.label !== "") {
				classList += " has-label";
			}

			if (this.help !== "") {
				classList += " has-help";
			}

			if (this.hasSuccess) {
				classList += " has-success";
			}

			if (this.hasError || this.error) {
				classList += " has-error";
			}

			if (this.isLoading) {
				classList += " is-loading";
			}

			if (this.isFull) {
				classList += " is-full";
			}

			if (this.required) {
				classList += " is-required";
			}

			if (this.hasFocus) {
				classList += " has-focus";
			}

			classList += " resize-" + this.resizeType;

			return classList;
		},
	},

	mounted() {
		if (this.has_prefix) {
			const currentPaddingLeft =
				getComputedStyle(this.$el.querySelector(".input")).getPropertyValue("padding-left").replace("px", "") *
				1;
			this.generatedInputStyles.push({
				type: "padding-left",
				value: this.$el.querySelector(".input-prefix").clientWidth + currentPaddingLeft + "px",
			});
		}

		if (this.has_suffix) {
			const currentPaddingRight =
				getComputedStyle(this.$el.querySelector(".input")).getPropertyValue("padding-right").replace("px", "") *
				1;
			this.generatedInputStyles.push({
				type: "padding-right",
				value: this.$el.querySelector(".input-suffix").clientWidth + currentPaddingRight + "px",
			});
		}
	},
};
</script>
